import OppleModal from '@/components/OppleModal/index.vue'
import vuescroll from 'vuescroll'
import vScence from '@/components/common/scenceSelect.vue'
import vIfttt from '@/components/common/iftttSelect.vue'
import vCds from '@/components/common/courseDataySync.vue'
import vHcl from '@/components/common/hclSelect'
import selectArea from '@/components/common/selectArea.vue'
import actionAirCondition from '@/components/common/actionAirCondition.vue'
import { alerterror, alertsuccess, warning, error } from '@/assets/js/common.js'
import { FindDevice, BatchSearchFirmwareVersion } from '@/axios/IDevice.js'
import { Create, Find, Edit, CreateTimeSequence, EditTimeSequence } from '@/axios/IFttt.js'
import colorPicker from '@/components/deviceAction/colorPicker/main.vue'
import colorPickers from '@/components/deviceAction/colorPickers'
import ModeRadio from '@/components/button/ModeRadio.vue'
import { isMatched,getIftttShowMode } from '@/utils/utils'
import IfftttDeviceDialog from '../components/IfftttDeviceDialog.vue';
import controlItem from '@/components/common/controlItem'
import OpActionContainer from '@/components/common/layer/OpActionContainer.vue'
import { APP_SHOW_MODE_ENUM, UICONTROL_CX_CY_WithMode_ARRAY, PROJECTTYPE_ENUM } from '@/utils/enums'
import IfftttEffectTimeDialog from '../components/IfftttEffectTimeDialog.vue'
import IftttOptionTime from '../components/IftttOptionTime.vue'
import IftttExecuteType from '../components/iftttExecuteType';
import otaUpdateDidalog from '@/page/install/area/otaUpdateDidalog.vue'
import { parseVersionName } from '@/utils/parseVersionName.js'
import OpDialog from '@/components/common/OpDialog.vue'
import IftttTianmuVideo from '../components/IftttTianmuVideo.vue'
import AreaControlList from '@/page/ifttt/components/AreaControlList.vue'
import AgricultureAreaControlList from '@/page/ifttt/components/AgricultureAreaControlList.vue'
import AgricultureAreaControl from '@/components/common/AgricultureAreaControl.vue'
import sceneCard from '@/components/common/scenceCard.vue'
import OppleTimerSettings from '@/components/OppleTimerSettings/index.vue'
import IfftttSunDialog from '../components/IfftttSunDialog.vue'
import IftttOptionCount from '@/page/ifttt/components/IftttOptionCount.vue'

const mixins ={
  components: {
    OppleTimerSettings,
    vuescroll,
    // vChoose,
    vScence,
    vIfttt,
    vCds,
    selectArea,
    actionAirCondition,
    vHcl,
    colorPicker,
    colorPickers,
    IfftttDeviceDialog,
    ModeRadio,
    controlItem,
    OpActionContainer,
    OppleModal,
    IfftttEffectTimeDialog,
    IftttOptionTime,
    IftttOptionCount,
    IftttExecuteType,
    otaUpdateDidalog,
    OpDialog,
    IftttTianmuVideo,
    AreaControlList,
    AgricultureAreaControlList,
    AgricultureAreaControl,
    sceneCard,
    IfftttSunDialog
  },
  props: {
    noSave: {
      type: Boolean,
      default: false
    },
    isNavigate: {
      type: Boolean,
      default: true
    },
    isTriggle: { // 显示如果
      type: Boolean,
      default: true
    },
    isAction: { // 显示就执行
      type: Boolean,
      default: true
    },
    isSchedule: { // 显示生效
      type: Boolean,
      default: true
    },
    isJumpBackPage: { // 是否跳回
      type: Boolean,
      default: true
    },
    isRegularTriggle: {
      type: Boolean,
      default: false
    },
    isNeedRequestTriggger: {
      type: Boolean,
      default: true
    },
    isCustomBack: {
      type: Boolean,
      default: false
    },
    /**
     * {
     * GpNo: null,
     * IFtttNo: null,
     * IFtttName: '',
     * IsEnable: true,
     * IsManual: false,
     * TRI_Relation: 0,
     * TriggerType: 4,
     * TriggerList: [{AreaName:null,DeviceName:'',VDeviceId:'',TriggerType:1,TriggerList[{ExtraKeyId:2,KeyId:2,MsgId:'',OperationType:1,Value1:6}]}],
     * ExecuteTaskList: [{ActionType:1,DelayTime:1}],
     * TimePeriod: {time:"00:00",weeks:"Mon Tues Wed Thur Fri Sat Sun",zone:480}
     *
     * }
     */
    iftttSetParam: { // 自动化配置内容数据
      type: Object,
      default: null
    },
    isInitCreateRequest: {
      type: Boolean,
      default: true
    },
    showEntry: {
      type: Number,
      default: null
    },
    gpNo: {
      type: Number,
      default: null
    },
    isVisual: {
      type: Boolean,
      default: false
    },
    initPanelData: {
      type: Object,
      default: ()=>({})
    },
    isInnoTrigger:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      removecurrent: [],
      isloading: false, // 提交的loading动画
      name: '', // 自动化名称
      checkShow: true, // 未知
      iftttOption: [{ id: 1, name: this.$t('iftttset.officeAutomation'), is_del: true }],
      TRI_Relation: 0,
      value1: '',
      value2: '',
      value3: '',
      parameters: null, // 参数对象
      iftttmodel: null, // 编辑对象 整个ifttt参数
      cur: -1, // 未知 感觉无效参数
      temdevice: {}, // 选中的设备对象(设备卡选中)
      IsManual: false, // 是否手动
      postdata: {}, // 提交的数据
      modifyItem: null, // 修改对象 action trigger 都可能
      titleText:'',
      APP_SHOW_MODE_ENUM,
      UICONTROL_CX_CY_WithMode_ARRAY,
      PROJECTTYPE_ENUM,
    }
  },
  computed: {
    pageType () {
      return this.parameters.IFT_ID ? 'edit' : 'create'
    },
  },
  created () {
    if (getLocalStoragItem('ifttt')) {
      this.parameters = JSON.parse(getLocalStoragItem('ifttt'))

      if (this.gpNo) {
        this.parameters.GpNo = this.gpNo
      }

      // 创建模式下设置定时序列自动化模式
      if (!this.parameters.IFT_ID && this.parameters.isTimeSequenceAutomation) {
        this.isTimeSequenceAutomation = true;
      }

      // 创建模式下设置循环序列自动化模式
      if (!this.parameters.IFT_ID && this.parameters.isLoopAutomation) {
        this.isLoopAutomation = true;
      }

      if (this.isInitCreateRequest === false) return;
      this.getIsExistGSDevice()
      
    }
  },
  methods: {
    getIftttShowMode,
    isMatched:isMatched,
    chooseDeviceInMap(checckdata,alreadychecked){
      this.hidenDeviceDialogDialog()
      this.$emit('chooseDeviceInMap',checckdata,alreadychecked)
    },
    hidenDeviceDialogDialog() {
      this.dialogAction = false;
      this.dialogGroup = false;
      this.handleClose()
    },

    async doFind () {
      const res = await Find({ 
        iftttNo: this.parameters.IFT_ID,
        supportIfttt4: true,
      });

      if (res.StatusCode === this.$store.state.rightStatusCode) {
        this.iftttSetParamMake(res.Result);

        this.optionTimeData = res.Result.TimePeriod;

        this.seqCycleNum = res.Result.SeqCycle

        this.$emit('iftttSetParamMake', res.Result);

        return;
      }
      alerterror(this, res.StatusCode)
    },

    iftttSetParamMake (param) {
      if (param.IFtttNo != null) { this.parameters.IFT_ID = param.IFtttNo } else { this.parameters.IFT_ID = null }

      this.deviceOption = []
      this.timeOption = []
      this.triggermanual = []
      this.allactionlist = []
      this.scenelist = []
      this.switchifttt = []
      this.handleifttt = []

      this.iftttmodel = param
      this.name = this.iftttmodel.IFtttName
      this.TRI_Relation = this.iftttmodel.TRI_Relation

      if (this.TRI_Relation === 0) {
        this.titlevalue = this.$t('iftttset.allcondition')
      } else if (this.TRI_Relation === 1) {
        this.titlevalue = this.$t('iftttset.onecondition')
      } else {
        this.titlevalue = this.$t('iftttset.select')
      }

      // 检查是否为定时序列自动化
      this.checkIfIfttt4(param);

      if (this.isNeedRequestTriggger && param.TriggerType !== 11) {
        this.eidtorTriggerformate()
      }
      
      this.eidtorAllActionList() // 所有actin
      this.editorSceneformate()
      this.eidtorIftttformate()
      this.eidtorIfttthandleformate()
      
      // 初始化IFTTT 4.0定时序列数据
      this.initIfttt4Data(param)
      
      this.IsManual = this.iftttmodel.IsManual
      if (this.IsManual) {
        // 手动执行
        this.triggerTypeList.forEach(n => {
          n.disabled = true
        })
      } else {
        this.triggerTypeList.forEach(n => {
          if (n.value === 'c') {
            n.disabled = true
          }
        })
      }
    },
    eidtorIfttthandleformate () {
      // ifttt手动执行编辑初始化数据
      this.iftttmodel.ExecuteTaskList.forEach(n => {
        if (n.ActionType === 7) {
          this.handleifttt.push({
            IFT_ID: n.IFtttNo,
            IFT_Name: n.IFtttName
          })
        }
      })
    },
    editorSceneformate () {
      // 场景编辑初始化数据
      this.iftttmodel.ExecuteTaskList.forEach(n => {
        if (n.ActionType === 4) {
          this.scenelist.push({
            SceneName: n.SceneName,
            SceneNo: n.SceneNo
          })
        }
      })
    },
    /**
     * 保存 && 创建自动化 方法调用
     */
    saveIfttt () {
      // 定时序列自动化模式下的验证
      if (this.isTimeSequenceAutomation) {
        if (this.sequenceTaskList.length === 0) {
          warning(this, this.$t('iftttset.pleaseAddOneSequenceStep'));
          return;
        }
        // 验证每个定时序列步骤是否都有动作
        const hasEmptyTask = this.sequenceTaskList.some(task => !task.ActionList || task.ActionList.length === 0);
        if (hasEmptyTask) {
          warning(this, this.$t('ifttt.eachStepNeedsActionItem'));
          return;
        }
      } else if (this.isLoopAutomation) {
        // 循环自动化验证 - 使用传统验证逻辑
        if (this.allactionlist.length === 0) {
          warning(this, this.$t('iftttset.actionwarning'));
          return;
        }
        if (!this.allactionlist.some(action => action.ActionType === 1)) {
          warning(this, this.$t('iftttset.pleaseAddOneDelayItem'));
          return;
        }
      } else {
        // 传统模式验证
        if (this.timeOption.length + this.deviceOption.length > this.$store.state.deployParamter.ifttt.triggershowtotal ||
          this.allactionlist.length > this.$store.state.deployParamter.ifttt.actionshowtotal
        ) {
          warning(this, this.triggerAndActionWarmTip())
          return
        }
      }

      this.getpostData()
    },
    async findDeviceInfo(rs){
      debugger
      let titleArr = []
      let repeatInfo = this.$refs.iftttOptionTime && this.$refs.iftttOptionTime.getFullData()?.repeatInfo
      if(repeatInfo && repeatInfo !== this.$t('iftttset.every') && repeatInfo !== this.$t('iftttset.customize')){
          titleArr.push(`【 ${repeatInfo} 】`)
      }

     let hasPushed = false;
     this.postdata.ExecuteTaskList.forEach(item => {
       if (item.ActionType === 3 && item.IftttToggleInterval > 0 && !hasPushed) {
         titleArr.push(`【 ${this.$t("iftttset.delayedToggleAutomationSwitchState")} 】`);
         hasPushed = true;
        }
      });
      const otaWarnTitile = titleArr.join('、')
      await this.isGatewayOrDeviceUpgradeSupported()
      if(this.otaGatewaySupportShow ){
       
        this.titleText = this.ifttt3Tip(false, otaWarnTitile)
        return;
      }
      const ExtensionData = rs.ExtensionData.split(',');
      if (ExtensionData[0] !== '0') {
        this.newDeviceSelected = [];
        this.otaWarnFlag = true;
       
       
        this.titleText = this.ifttt3Tip(true,otaWarnTitile)

        // 使用 Promise.all 并发调用以优化性能
        const promises = ExtensionData.map(async (vDeviceId) => {
          const param1 = { vDeviceId: vDeviceId, channelId: 65535 };
          const param2 = { vDeviceId: vDeviceId, searchIp: false };
          const deviceInfoRes = await FindDevice(param1);
          const versionInfoRes = await BatchSearchFirmwareVersion(param2);
          return {...deviceInfoRes.Result,LocalVersion:parseVersionName(versionInfoRes.Result.LocalVersion),LatestVersion:parseVersionName(versionInfoRes.Result.LatestedVersion)}; // 假设接口返回结构包含 Result
        })

        try {
          const deviceInfos = await Promise.all(promises); // 等待所有查询完成
          console.log('deviceInfos', deviceInfos);

          this.newDeviceSelected.push(...deviceInfos); // 添加所有设备信息
        } catch (error) {
          console.error('设备查询失败:', error);
        }
      }
    },
    async functionDoCreate (rs) {      
      this.isloading = false
      if (rs.StatusCode === this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        let arg = arguments[1]
        const isCopy = this.$route.query && this.$route.query.openType === 'copy'
        if (this.parameters.IFT_ID && !isCopy) {
          arg.iftttNo = this.parameters.IFT_ID
          arg.IFtttNo = this.parameters.IFT_ID
          this.$emit('postEvent', arg)
          this.removecurrent.push({ iftttNo: this.parameters.IFT_ID })
          this.cancle();
        } else {
          if (rs.Result != null) {
            arg.iftttNo = rs.Result
            arg.IFtttNo = rs.Result
            this.$emit('postEvent', arg)
            this.removecurrent.push({ iftttNo: rs.Result })
            this.cancle();
          } else {
            this.cancle()
          }
          arg = null
        }


        // this.$router.push({ name: 'automation', params: { data: JSON.stringify(this.parameters) } });
      }else if(rs.StatusCode === this.$store.state.ifttt3StatusCode){
        alerterror(this, rs.StatusCode)
        this.findDeviceInfo(rs);
      }else if(rs.StatusCode === this.$store.state.ifttt3StatusCode2){
        alertsuccess(this, rs.StatusCode)
      }
      else {
        alerterror(this, rs.StatusCode)
      }
    },
    // 改
    getpostData () {
      debugger
      
      // 根据自动化类型获取对应的时间配置
      if (this.isLoopAutomation && this.$refs.iftttOptionCount) {
        this.TimePeriod = this.$refs.iftttOptionCount.getDefaultTimePeriod()
      } else if (this.$refs.iftttOptionTime) {
        this.TimePeriod = this.$refs.iftttOptionTime.getSaveData()
      }
      
      if(this.triggermanual.length !== 0){
        this.TimePeriod = {
            effectivedate : '2019-01-01,2088-12-31',
            holiday : false,
            time : '00:00',
            weeks : 'Mon Tues Wed Thur Fri Sat Sun',
            zone : 0,
            flag : 1,
        }
      }
      
      if (this.TimePeriod.time === '' ) {
        this.TimePeriod.time = '00:00'
      }
      if (this.name === '') {
        warning(this, this.$t('iftttset.namewarning'))
        return
      }
      if (!this.TimePeriod.weeks) {
        warning(this, this.$t('iftttset.effectivetimewarning'))
        return
      }
      if (this.TRI_Relation === -1) {
        warning(this, this.$t('iftttset.conditions'))
        return
      }

      if (this.timeOption.length > 0 && this.sunOption) {
        warning(this, this.$t('iftttset.timeOrSunExclusive'))
        return
      }
      
      const hasInnoTriggerFromModel = this.isInnoTrigger && (this.iftttmodel?.TriggerList?.length > 0)

      if (this.isLoopAutomation === false && this.isTimeSequenceAutomation === false && this.triggermanual.length === 0 && this.deviceOption.length === 0 && this.timeOption.length === 0 && this.sunOption === null && !hasInnoTriggerFromModel) {
        warning(this, this.$t('iftttset.triggerwarning'))
        return
      }

      this.postdata.GpNo = this.parameters.GpNo
      this.postdata.IFtttName = this.name
      let _triggerlist = []
      // console.log(this.deviceOption);

      this.deviceOption.forEach(n => {
        let _tem = -1
        for (let i = 0; i < _triggerlist.length; i++) {
          if (n.VDeviceId === _triggerlist[i].VDeviceId) {
            _tem = i
          }
        }

        if (_tem === -1) {
          // 新增设备trigger

          const _tmodel = {
            PhyPosition: n.triggle.PhyPosition,
            MsgId: n.triggle.MsgID,
            KeyId: n.triggle.KeyID,
            ExtraKeyId: n.triggle.ExtraKeyId,
            OperationType: n.triggle.OperationValue
          }
          if (n.triggle.ValueType === 'UIControl_ChooseRange' || n.triggle.ValueType === 'UIControl_MultipleDropdownList') {
            _tmodel.Value1 = n.triggle.DefaultValue[0]
            _tmodel.Value2 = n.triggle.DefaultValue[1]
          } else if(n.triggle.ValueType === 'UIControl_Slider' && n.triggle.OperationValue === 8){
            _tmodel.Value1 = n.triggle.DefaultValue[0]
            _tmodel.Value2 = n.triggle.DefaultValue[1]
          } else {
            _tmodel.Value1 = n.triggle.DefaultValue
          }

          let _trigger = {}
          _trigger.VDeviceId = n.VDeviceId
          _trigger.DeviceName = n.DeviceName
          _trigger.AreaName = n.AreaName
          _trigger.TriggerType = 1
          _trigger.TriggerList = []
          _trigger.TriggerList.push(_tmodel)
          _triggerlist.push(_trigger)
          _trigger = null
        } else {
          const _tmodel = {
            PhyPosition: n.triggle.PhyPosition,
            MsgId: n.triggle.MsgID,
            KeyId: n.triggle.KeyID,
            ExtraKeyId: n.triggle.ExtraKeyId,
            OperationType: n.triggle.OperationValue
          }

          if (n.triggle.ValueType === 'UIControl_ChooseRange' || n.triggle.ValueType === 'UIControl_MultipleDropdownList') {
            _tmodel.Value1 = n.triggle.DefaultValue[0]
            _tmodel.Value2 = n.triggle.DefaultValue[1]
          } else if(n.triggle.ValueType === 'UIControl_Slider' && n.triggle.OperationValue === 8){
            _tmodel.Value1 = n.triggle.DefaultValue[0]
            _tmodel.Value2 = n.triggle.DefaultValue[1]
          } else {
            _tmodel.Value1 = n.triggle.DefaultValue
          }

          _triggerlist[_tem].TriggerList.push(_tmodel)
        }
        _tem = null
        // _tmodel=null;
      })

      if (_triggerlist.length === 0 && hasInnoTriggerFromModel) {
        _triggerlist = this.iftttmodel.TriggerList
      }

      // console.log(_triggerlist);
      if (this.timeOption.length > 0) {
        this.timeOption.forEach(n => {
          // _triggerlist.push(n);
          _triggerlist.push({
            time: this.timeOption[0],
            weeks: this.TimePeriod.weeks,
            zone: 0,
            TriggerType: 0
          })
        })
      }
      debugger

      //定时序列自动化
      if (this.sequenceTaskList.length > 0) {
          _triggerlist.push({
            time: '00:00',
            weeks: this.TimePeriod.weeks,
            zone: 0,
            TriggerType: 0
        })
      }

      // 循环自动化 - 添加特殊的 TriggerType: 4
      if (this.isLoopAutomation) {
        _triggerlist = [{
          TriggerType: 4
        }];
      }

      // 添加日出日落
      if (this.sunOption) {
        _triggerlist.push({
          TriggerType: 3,
          Mode: this.sunOption.Mode,
          Offset: this.sunOption.Offset,
          Longitude: this.sunOption.Longitude,
          Latitude: this.sunOption.Latitude
        })
      }

      // 添加手动自动化
      if (Number.isInteger(this.showEntry)) {
        this.postdata.ShowEntry = this.showEntry
      }

      if (this.triggermanual.length > 0) {
        _triggerlist.push(this.triggermanual[0])
        this.IsManual = true
      }
      this.postdata.IsManual = this.IsManual
      this.postdata.TriggerList = _triggerlist
      // 添加执行对象
      let _temtasklist = []
      console.log('........... this.allactionlist.',this.allactionlist)
      this.allactionlist.forEach(n => {
        if (n.ActionType === 4) {
          // 场景
          _temtasklist.push({
            ActionType: 4,
            SceneNo: n.SceneNo,
            SceneName: n.SceneName
          })
        } else if (n.ActionType === 3) {
          const IftttToggleInterval = 
            (this.iftttReverseDelayTime?.[n.IFT_ID]?.hour * 3600 || 0) + 
            (this.iftttReverseDelayTime?.[n.IFT_ID]?.minute * 60 || 0) + 
            (this.iftttReverseDelayTime?.[n.IFT_ID]?.second || 0);
          // 如果 IftttToggleInterval 为 （或其他无效值），返回 undefined
          const finalIftttToggleInterval = (IftttToggleInterval >= 0) ? IftttToggleInterval : undefined;
          // 开关自动化
          _temtasklist.push({
            ActionType: 3,
            IFtttNo: n.IFT_ID,
            IFtttName: n.IFT_Name,
            IsEnable: n.IsEnable,
            IftttToggleInterval: finalIftttToggleInterval
          })
        } else if (n.ActionType === 7) {
          // 执行自动化
          _temtasklist.push({
            ActionType: 7,
            IFtttNo: n.IFT_ID,
            IFtttName: n.IFT_Name
          })
        } else if (n.ActionType === 8) {
          // 执行自动化
          _temtasklist.push({
            ActionType: 8,
            HCLId: n.HCLId,
            HCLName: n.HCLName,
            ActionName: n.HCLName,
            IsEnable: n.IsEnable,
            IsDel: false
          })
        } else if (n.ActionType === 0) {
          // var _actionlist = [];
          let _model = {
            ActionType: 0,
            VDeviceId: n.VDeviceId,
            DeviceName: n.DeviceName,
            AreaName: n.AreaName,
            ChannelId: n.ChannelId,
            ActionList: [],
            backupActionList:[]
          }

          if (n.ActionList) {
            // console.log(n.ActionList);
            const func = (list,key)=>{
             let filterList =  list.filter((item,index,array)=>{
                let isMatched = this.isMatched(item,n.allActionlist,2)
                // 过滤掉已经选择的MsgType
                if(isMatched && key === 'backupActionList'){
                  isMatched = _model.ActionList.findIndex(m=>{
                    return m.MsgType === item.MsgType
                  }) === -1
                }
               return isMatched
             })
             console.log('filterList',filterList,key,list)
             let MsgTypeJson = {};
             filterList.forEach(m => {
              let _actionmodel = {}
              _actionmodel.MsgType = m.MsgType
              _actionmodel.Values = []
              m.Values.forEach(t => {

              // 分钟转为秒秒
              let value = this.LightActionValueSubmit(t);

              if (Number.isInteger(t.UI?.step)) {
                value = Math.ceil(value * t.UI?.step)
              }
                _actionmodel.Values.push({
                  KeyId: t.KeyId,
                  Value: value
                })
              })
              if(!MsgTypeJson[m.MsgType]){
                _model[key].push(_actionmodel)
                MsgTypeJson[m.MsgType] = true
              }
              _actionmodel = null
            })
            }
            func(n.ActionList,'ActionList')
            func(n.allActionlist,'backupActionList')
            // n.ActionList.filter((item,index,array)=>{
            //   return this.isMatched(item,n.allActionlist)
            // }).forEach(m => {
            //   let _actionmodel = {}
            //   _actionmodel.MsgType = m.MsgType
            //   _actionmodel.Values = []
            //   m.Values.forEach(t => {
            //     _actionmodel.Values.push({
            //       KeyId: t.KeyId,
            //       Value: this.LightActionValueSubmit(t)
            //     })
            //   })
            //   _model.ActionList.push(_actionmodel)
            //   _actionmodel = null
            // })
            
          }
          // _actionlist.push({
          //
          // });
          _temtasklist.push(_model)
          // _actionlist.push(_model);
          _model = null
        } else if (n.ActionType === 1) {
          let _value = n.time.split(':')
          let _hours = parseInt(_value[0]) * 3600
          let _minutes = parseInt(_value[1]) * 60
          let _seconds = parseInt(_value[2])
          _temtasklist.push({
            ActionType: 1,
            DelayTime: _hours + _minutes + _seconds
          })
          _value = null
          _hours = null
          _minutes = null
          _seconds = null
        } else if (n.ActionType === 6) {
          let _model = {
            ActionType: n.ActionType,
            Gpno: n.Gpno,
            AreaName: n.AreaName,
            Values: []
          }
          if (n.ActionList != null) {
            let _actionmodel
            n.ActionList.forEach(m => {
              _actionmodel = {
                ControlType: m.ControlType,
                ChannelId: this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture ? m.ChannelId : undefined
              }
              if (m.ControlType === 2) {
        
                let _int = '0x' + m.Values[0].DefaultValue.substr(1)
                _actionmodel.Value = parseInt(_int)
                _int = null
              } else {
                _actionmodel.Value = this.LightActionValueSubmit(m.Values[0])
              }
              _model.Values.push(_actionmodel)
            })
            _actionmodel = null
          }
          _temtasklist.push(_model)
          _model = null
        }
      })

      this.postdata.ExecuteTaskList = _temtasklist
      
      // 处理定时序列自动化数据
      if (this.isTimeSequenceAutomation) {
        this.postdata = this.processIfttt4DataForSave(this.postdata);
      }
      
      // 循环自动化不需要特殊处理，使用传统逻辑即可
      
      if (this.postdata.ExecuteTaskList.length === 0) {
        warning(this, this.$t('iftttset.actionwarning'))
        return
      }
      this.postdata.TRI_Relation = this.TRI_Relation
      this.postdata.TimePeriod = this.TimePeriod
      this.postdata.SeqCycle = this.$refs.iftttOptionCount && this.$refs.iftttOptionCount.getRadioValue()
      //自动化3.0
      this.isloading = true

      // 复制自动化 - 需要当做 create；定时序列走 CreateTimeSequence，与新建一致
      if (this.$route.query && this.$route.query.openType === 'copy') {
        const copyApi = this.isTimeSequenceAutomation ? CreateTimeSequence : Create
        copyApi(this.postdata, this.functionDoCreate)
        return
      }

      if (this.parameters.IFT_ID) {
        this.postdata.IFtttNo = this.parameters.IFT_ID
        delete this.postdata.iftttNo
      }

        // 定时序列自动化使用特殊API，循环自动化和传统自动化使用普通API
        const apiMethod = this.parameters.IFT_ID
          ? (this.isTimeSequenceAutomation ? EditTimeSequence : Edit)
          : (this.isTimeSequenceAutomation ? CreateTimeSequence : Create)
        apiMethod(this.postdata, this.functionDoCreate)
      // console.log(this.allactionlist);
      _triggerlist = null
      _temtasklist = null
    },
  }
}

export default mixins;